import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import LanguageTranslator from '../../../../locals/LanguageTranslator';
import { GRC_FULFILLMENT_LABELS, GRC_RECEIVED_CARDS, TRANSACTION_DETAIL_CARDS } from '../businessDashboardConstants';
import { dispatchHandler } from '../../../../helper/apiHelperFunctions';
import { formatNumber } from '../../../../helper/genericFunction';

function GrcIcon() {
  return (
    <div className="relative shrink-0 size-[24px]">
      <div className="absolute bg-[#03b675] left-0 rounded-[5px] size-[24px] top-0" />
      <div className="-translate-x-1/2 -translate-y-1/2 absolute left-1/2 size-[18px] top-1/2">
        <svg className="absolute block inset-0 size-full" fill="none" height="18" preserveAspectRatio="none" viewBox="0 0 18 18" width="18">
          <g>
            <path d="M11.2352 1.84375H6.76128C6.34947 1.84375 6.01562 2.17759 6.01562 2.58941V4.08072C6.01562 4.49254 6.34947 4.82638 6.76128 4.82638H11.2352C11.647 4.82638 11.9809 4.49254 11.9809 4.08072V2.58941C11.9809 2.17759 11.647 1.84375 11.2352 1.84375Z" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M11.9791 3.33594H13.4705C13.866 3.33594 14.2453 3.49306 14.525 3.77273C14.8047 4.05241 14.9618 4.43173 14.9618 4.82725V14.709C14.9618 15.1046 14.8047 15.4839 14.525 15.7636C14.2453 16.0432 13.866 16.2004 13.4705 16.2004H4.52257C4.12704 16.2004 3.74772 16.0432 3.46805 15.7636C3.18837 15.4839 3.03125 15.1046 3.03125 14.709V4.82725C3.03125 4.43173 3.18837 4.05241 3.46805 3.77273C3.74772 3.49306 4.12704 3.33594 4.52257 3.33594H6.01388" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M11.162 8.22656L7.20493 12.1837L5.40625 10.385" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M12.597 9.67188L9.89898 12.3699L9.35938 11.8303" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
          </g>
        </svg>
      </div>
    </div>
  );
}

function ClockIcon() {
  return (
    <div className="relative shrink-0 size-[24px]">
      <div className="absolute bg-[#fe9d0b] left-0 rounded-[5px] size-[24px] top-0" />
      <div className="absolute left-[3px] size-[18px] top-[3px]">
        <svg className="absolute block inset-0 size-full" fill="none" height="18" preserveAspectRatio="none" viewBox="0 0 18 18" width="18">
          <g>
            <path d="M12 10.5V12.15L13.2 12.9" stroke="white" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.2" />
            <path d="M12 1.5V3.75" stroke="white" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.2" />
            <path d="M15.75 5.5035V3.75C15.75 3.35218 15.592 2.97064 15.3107 2.68934C15.0294 2.40804 14.6478 2.25 14.25 2.25H3.75C3.35218 2.25 2.97064 2.40804 2.68934 2.68934C2.40804 2.97064 2.25 3.35218 2.25 3.75V14.25C2.25 14.6478 2.40804 15.0294 2.68934 15.3107C2.97064 15.592 3.35218 15.75 3.75 15.75H5.5035" stroke="white" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.2" />
            <path d="M2.25 6.75H6.64425" stroke="white" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.2" />
            <path d="M6 1.5V3.75" stroke="white" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.2" />
            <path d="M12 16.5C14.4853 16.5 16.5 14.4853 16.5 12C16.5 9.51472 14.4853 7.5 12 7.5C9.51472 7.5 7.5 9.51472 7.5 12C7.5 14.4853 9.51472 16.5 12 16.5Z" stroke="white" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.2" />
          </g>
        </svg>
      </div>
    </div>
  );
}

function PendingIcon() {
  return (
    <div className="relative shrink-0 size-[24px]">
      <div className="absolute bg-[#5d5fef] left-0 rounded-[5px] size-[24px] top-0" />
      <div className="absolute left-[3px] size-[18px] top-[3px]">
        <svg className="absolute block inset-0 size-full" fill="none" height="18" preserveAspectRatio="none" viewBox="0 0 18 18" width="18">
          <g>
            <path d="M8.25 11.25H9.75C10.1478 11.25 10.5294 11.092 10.8107 10.8107C11.092 10.5294 11.25 10.1478 11.25 9.75C11.25 9.35218 11.092 8.97064 10.8107 8.68934C10.5294 8.40804 10.1478 8.25 9.75 8.25H7.5C7.05 8.25 6.675 8.4 6.45 8.7L2.25 12.75" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M5.25 15.7458L6.45 14.6958C6.675 14.3958 7.05 14.2458 7.5 14.2458H10.5C11.325 14.2458 12.075 13.9458 12.6 13.3458L16.05 10.0458C16.3394 9.7723 16.5083 9.39503 16.5196 8.99699C16.5308 8.59894 16.3835 8.21273 16.11 7.92331C15.8365 7.63389 15.4592 7.46498 15.0612 7.45373C14.6631 7.44247 14.2769 7.5898 13.9875 7.86331L10.8375 10.7883" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M1.5 12L6 16.5" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M12.0031 8.92812C13.2043 8.92812 14.1781 7.95434 14.1781 6.75313C14.1781 5.55191 13.2043 4.57812 12.0031 4.57812C10.8019 4.57812 9.82812 5.55191 9.82812 6.75313C9.82812 7.95434 10.8019 8.92812 12.0031 8.92812Z" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M4.5 6C5.74264 6 6.75 4.99264 6.75 3.75C6.75 2.50736 5.74264 1.5 4.5 1.5C3.25736 1.5 2.25 2.50736 2.25 3.75C2.25 4.99264 3.25736 6 4.5 6Z" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
          </g>
        </svg>
      </div>
    </div>
  );
}

function StatCard({ label, icon, qty, amount, invoice = 0, amountLarge = "₹ 0", bg = "bg-white" }) {
  let IconComponent = null;
  if (icon === "grc") IconComponent = <GrcIcon />;
  else if (icon === "clock") IconComponent = <ClockIcon />;
  else if (icon === "pending") IconComponent = <PendingIcon />;

  return (
    <div className={`${bg} content-stretch flex flex-1 flex-col min-w-0 h-[96px] items-start justify-between p-[10px] relative rounded-[10px]`}>
      <div aria-hidden className="absolute border border-[#dae4ee] border-solid inset-0 pointer-events-none rounded-[10px]" />
      <div className="content-stretch flex items-center justify-between relative shrink-0 w-full">
        <LanguageTranslator tag="p" className="[word-break:break-word] capitalize font-normal leading-[1.4] not-italic relative text-[#111d31] text-[11px] mb-0">{label}</LanguageTranslator>
        {IconComponent}
      </div>
      {qty !== undefined ? (
        <div className="[word-break:break-word] content-stretch flex items-start justify-between leading-[normal] not-italic relative shrink-0 w-full mt-auto">
          <div className="content-stretch flex flex-col items-start relative shrink-0 whitespace-nowrap">
            <LanguageTranslator tag="p" className="font-normal relative shrink-0 text-[#4a5d7a] text-[11px] mb-0">Qty</LanguageTranslator>
            <p className="font-semibold relative shrink-0 text-[#111d31] text-[14px] mb-0">{qty}</p>
          </div>
          <div className="content-stretch flex flex-col items-end relative shrink-0 text-right">
            <LanguageTranslator tag="p" className="font-normal relative shrink-0 text-[#4a5d7a] text-[11px] w-full mb-0">Amount</LanguageTranslator>
            <p className="font-semibold relative shrink-0 text-[#111d31] text-[14px] w-full mb-0">{amount}</p>
          </div>
        </div>
      ) : (
        <div className="[word-break:break-word] content-stretch flex items-center justify-between not-italic relative shrink-0 w-full mt-auto">
          <div className="content-stretch flex flex-[0.7] flex-col items-start leading-[normal] min-w-0 relative whitespace-nowrap">
            <LanguageTranslator tag="p" className="font-normal relative shrink-0 text-[#4a5d7a] text-[11px] mb-0">Invoice</LanguageTranslator>
            <p className="font-semibold relative shrink-0 text-[#111d31] text-[14px] mb-0">{invoice}</p>
          </div>
          <div className="flex flex-[1.3] flex-col font-semibold h-full justify-end leading-[0] min-w-0 relative text-[#111d31] text-[20px] text-right">
            <p className="leading-[normal] mb-0">{amountLarge}</p>
          </div>
        </div>
      )}
    </div>
  );
}

function GrcFulfilmentCard({ percentage = 0, pendingAmount = "₹ 0" }) {
  return (
    <div className="h-[96px] relative shrink-0 w-full lg:w-[330px]">
      <div
        className="absolute h-[96px] left-0 rounded-[10px] top-0 w-full lg:w-[330px]"
        style={{ backgroundImage: "linear-gradient(90deg, rgb(246, 251, 246) 0%, rgb(246, 251, 246) 100%), linear-gradient(90deg, rgb(255, 255, 255) 0%, rgb(255, 255, 255) 100%)" }}
      />
      <div className="-translate-y-1/2 [word-break:break-word] absolute capitalize flex flex-col font-normal justify-center leading-[0] left-[10px] not-italic text-[#111d31] text-[11px] top-[22px] whitespace-nowrap">
        <LanguageTranslator tag="p" className="leading-[1.4] mb-0">{GRC_FULFILLMENT_LABELS?.title}</LanguageTranslator>
      </div>
      <div className="absolute bg-[#d9d9d9] h-[6px] left-[10px] right-[10px] lg:w-[310px] rounded-[20px] top-[78px]" />
      <div className="absolute bg-[#03b675] h-[6px] left-[9.6px] rounded-[20px] top-[78px]" style={{ width: `${percentage}%`, maxWidth: 'calc(100% - 20px)' }} />
      <p className="-translate-x-full [word-break:break-word] absolute font-semibold leading-[normal] left-[51.6px] not-italic text-[#111d31] text-[20px] text-right top-[40px] whitespace-nowrap mb-0">{percentage}%</p>
      <div className="[word-break:break-word] absolute content-stretch flex flex-col h-[32px] items-start right-[10px] lg:left-[228px] not-italic top-[30px]">
        <LanguageTranslator tag="p" className="capitalize font-normal leading-[normal] relative shrink-0 text-[#4a5d7a] text-[11px] whitespace-nowrap mb-0">{GRC_FULFILLMENT_LABELS?.pendingLabel}</LanguageTranslator>
        <div className="flex flex-col font-semibold justify-center leading-[0] min-w-full relative shrink-0 text-[#fe9d0b] text-[14px] text-right w-[min-content] ml-auto">
          <p className="leading-[normal] mb-0">{pendingAmount}</p>
        </div>
      </div>
    </div>
  );
}

const GrcTransactionSection = () => {
  const dispatch = useDispatch();
  const getGrcReceivedSummaryData = useSelector(state => state?.digivendStore?.getGrcReceivedSummaryData || {});
  const getPoGrcKpiSummaryData = useSelector(state => state?.digivendStore?.getPoGrcKpiSummaryData || {});

  const [grcCards, setGrcCards] = useState((GRC_RECEIVED_CARDS || []).map(item => ({ ...item, qty: "0", amount: "₹ 0" })));
  const [fulfillment, setFulfillment] = useState({ percentage: 0, pendingAmount: "₹ 0" });
  const transCards = TRANSACTION_DETAIL_CARDS || [];

  useEffect(() => {
    dispatchHandler(dispatch, "getGrcReceivedSummaryRequest", { displayName: "GRC_KPI_SUMMARY" });
  }, [dispatch]);

  useEffect(() => {
    if (getGrcReceivedSummaryData?.isSuccess) {
      const resource = getGrcReceivedSummaryData?.data?.data?.resource || getGrcReceivedSummaryData?.data?.resource || {};

      const mapped = GRC_RECEIVED_CARDS.map(item => ({
        ...item,
        qty: (Number(resource?.[item?.qtyField]) || 0).toLocaleString('en-IN'),
        amount: `₹ ${formatNumber(resource?.[item?.amountField] || 0).short}`,
      }));

      setGrcCards(mapped);
    }
  }, [getGrcReceivedSummaryData?.isSuccess, getGrcReceivedSummaryData?.data]);

  useEffect(() => {
    if (getPoGrcKpiSummaryData?.isSuccess) {
      const res = getPoGrcKpiSummaryData?.data?.data?.resource || getPoGrcKpiSummaryData?.data?.resource || {};

      setFulfillment({
        percentage: typeof res.fulfillment_rate !== "undefined" ? Math.round(Number(res.fulfillment_rate)) : 0,
        pendingAmount: `₹ ${formatNumber(res.pending_amount || 0).short}`,
      });
    }
  }, [getPoGrcKpiSummaryData?.isSuccess, getPoGrcKpiSummaryData?.data]);

  return (
    <div className="flex flex-col gap-[12px] lg:flex-row w-full">
      {/* GRC Received */}
      <div className={`bg-white border border-[#dae4ee] border-solid flex-1 min-w-0 relative rounded-[10px] p-[14px] flex flex-col gap-[12px] ${getGrcReceivedSummaryData?.isLoading ? 'opacity-50 pointer-events-none' : ''}`}>
        <LanguageTranslator tag="p" className="[word-break:break-word] font-semibold leading-[normal] not-italic text-[#0f172a] text-[16px] whitespace-nowrap mb-0">GRC Received</LanguageTranslator>
        <div className="flex flex-col sm:flex-row gap-[12px]">
          {grcCards.slice(0, 2).map((item) => (
            <StatCard
              key={item.id}
              label={item.label}
              icon={item.icon}
              qty={item.qty}
              amount={item.amount}
            />
          ))}
        </div>
        <div className="flex flex-col lg:flex-row gap-[12px] items-start lg:items-center">
          {grcCards.slice(2, 3).map((item) => (
             <StatCard
               key={item.id}
               label={item.label}
               icon={item.icon}
               qty={item.qty}
               amount={item.amount}
             />
          ))}
          <GrcFulfilmentCard percentage={fulfillment.percentage} pendingAmount={fulfillment.pendingAmount} />
        </div>
      </div>

      {/* Transaction Details */}
      <div className="bg-white border border-[#dae4ee] border-solid flex-1 min-w-0 relative rounded-[10px] p-[14px] flex flex-col gap-[12px]">
        <LanguageTranslator tag="p" className="[word-break:break-word] font-semibold leading-[normal] not-italic text-[#0f172a] text-[16px] whitespace-nowrap mb-0">Transaction Details</LanguageTranslator>
        <div className="flex flex-col sm:flex-row gap-[12px]">
          {transCards.slice(0, 2).map((item) => (
            <StatCard
              key={item.id}
              label={item.label}
              icon={item.icon}
              invoice={item.invoice}
              amountLarge={item.amountLarge}
              bg={item.bg}
            />
          ))}
        </div>
        <div className="flex flex-col sm:flex-row gap-[12px]">
          {transCards.slice(2, 4).map((item) => (
            <StatCard
              key={item.id}
              label={item.label}
              icon={item.icon}
              invoice={item.invoice}
              amountLarge={item.amountLarge}
              bg={item.bg}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default GrcTransactionSection;
